import { Button } from '../ui/button';
import { Alert, AlertDescription } from '../ui/alert';
import { CheckCircle2, AlertTriangle, RefreshCw } from 'lucide-react';

export function InventoryResultStep({ importResult, onReset }) {
  if (!importResult) return null;

  return (
    <div className="space-y-4 text-center">
      {importResult.status === 'success' ? (
        <CheckCircle2 className="h-16 w-16 mx-auto text-emerald-500" />
      ) : (
        <AlertTriangle className="h-16 w-16 mx-auto text-amber-500" />
      )}

      <h3 className="text-xl font-semibold">
        {importResult.status === 'success' ? 'Import Completato!' : 'Import Parziale'}
      </h3>

      <p className="text-muted-foreground">{importResult.message}</p>

      <div className="flex justify-center gap-6 py-4">
        <div className="text-center">
          <p className="text-3xl font-bold text-emerald-600">{importResult.created}</p>
          <p className="text-sm text-muted-foreground">Creati</p>
        </div>
        <div className="text-center">
          <p className="text-3xl font-bold text-blue-600">{importResult.updated}</p>
          <p className="text-sm text-muted-foreground">Aggiornati</p>
        </div>
        <div className="text-center">
          <p className="text-3xl font-bold text-orange-600">{importResult.dismissed}</p>
          <p className="text-sm text-muted-foreground">Dismessi</p>
        </div>
      </div>

      {importResult.errors && importResult.errors.length > 0 && (
        <Alert variant="destructive" className="text-left">
          <AlertDescription>
            <strong>{importResult.errors.length} errori durante l'import:</strong>
            <ul className="mt-2 text-sm">
              {importResult.errors.slice(0, 5).map((err) => (
                <li key={`imp-err-${err.serial_number}`}>{err.serial_number}: {err.error}</li>
              ))}
            </ul>
          </AlertDescription>
        </Alert>
      )}

      <Button onClick={onReset} className="mt-4">
        <RefreshCw className="h-4 w-4 mr-2" />
        Nuovo Import
      </Button>
    </div>
  );
}
